export default "__VITE_ASSET__d6678ae6__"